import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-redux-form/immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { EditConfirmationModal } from './EditConfirmationModal';


export class EditForm extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const {
      create, update, isAdd, id, model, formData,
    } = this.props;
    if (isAdd) {
      create({
        data: formData.toJS(), goBack: true, formModel: model,
      });
    } else {
      update({
        id, data: formData.toJS(), goBack: true, formModel: model,
      });
    }
  }

  render() {
    const {
      children,
      hazardName,
      saving,
      model,
      handleOpen,
      handleCancel,
      editConfirmationOpen,
      formData,
      original,
    } = this.props;
    return (
      <div>
        <Form model={model} onSubmit={handleOpen} noValidate>
          <EditConfirmationModal
            isOpen={editConfirmationOpen}
            title={hazardName}
            saving={saving}
            onCancel={handleCancel}
            onSave={this.handleSubmit}
            updated={formData}
            existing={original}
          />
          {children}
        </Form>

      </div>
    );
  }
}

EditForm.propTypes = {
  children: PropTypes.node.isRequired,
  hazardName: PropTypes.string.isRequired,
  saving: PropTypes.bool.isRequired,
  model: PropTypes.string.isRequired,
  create: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired,
  isAdd: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  formData: ImmutablePropTypes.map.isRequired,
  original: ImmutablePropTypes.map.isRequired,
  editConfirmationOpen: PropTypes.bool.isRequired,
  handleOpen: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
};
